


import Headroom from "headroom.js";


import Lenis from "@studio-freight/lenis";


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


import SplitType from "split-type";


import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";


import Plyr from "plyr";
import "plyr/dist/plyr.css";


import confetti from "canvas-confetti";


import Atropos from "atropos";
import "atropos/atropos.css";
import VanillaTilt from "vanilla-tilt";


import ScrollOut from "scroll-out";


import { Curtains, Plane } from "curtainsjs";


import lottie from "lottie-web";


import { CountUp } from "countup.js";


import Vivus from "vivus";


import {
  Application,
  Sprite,
  DisplacementFilter,
  Assets,
  Texture,
  WRAP_MODES,
} from "pixi.js";


export async function initAllLibraries() {
  
  gsap.registerPlugin(ScrollTrigger);

  return true;
}



export {
  
  Headroom,
  Lenis,

  
  gsap,
  ScrollTrigger,

  
  SplitType,

  Plyr,

  
  confetti,

  
  Atropos,
  VanillaTilt,

  
  ScrollOut,

  
  Curtains,
  Plane,
  lottie,

  
  CountUp,

  
  Vivus,

  
  Application,
  Sprite,
  DisplacementFilter,
  Assets,
  Texture,
  WRAP_MODES,
};
